import { createReducer, on } from "@ngrx/store"
import { getAllAuthenticationLog, getAllAuthenticationLogSuccess, getAllAuthenticationLogFailure } from "../actions/authentication-log.action"

export interface AuthenticationLogState {
  authenticationLog: any
}

export const initialState: AuthenticationLogState = {
  authenticationLog: {
    content: [],
    totalPages: 0,
    totalElements: 0,
    pageable: {
      pageNumber: 0,
      pageSize: 20
    }
  }
}

export const authenticationLogReducer = createReducer(
  initialState,
  on(getAllAuthenticationLog, (state) => ({ ...state })),
  on(getAllAuthenticationLogSuccess, (state, { authenticationLogs }) => ({ ...state, authenticationLogs })),
  on(getAllAuthenticationLogFailure, (state, { error }) => ({ ...state, error }))
)